import ClipperPlaceholder from './ClipperPlaceholder.jsx';

export default function NovedadesEntregasConformeEnGral() {
  return (
    <ClipperPlaceholder title="Entregas Conforme en Gral" category="Novedades" />
  );
}
